<template>
  <household-browser search all />
</template>

<script>
import HouseholdBrowser from '@/components/HouseholdBrowser'
export default {
  name: 'AdminHouseholdsIndex',
  components: {
    HouseholdBrowser
  },
  data: () => ({
  })
}
</script>